import TitlePage from '../../components/TitlePage/TitlePage'
import React, { useEffect, useState } from 'react'
import { Grid, Card, Icon, Modal, Button, Tab } from '@scuf/common'
import PilaDomo2 from '../../components/Charts/Domo2/PilaDomo2'
import TablaGeneralDomo from '../../components/Charts/Domo2/TablaGeneralDomo'
import ResumenSumatoriaDomo2 from '../../components/Charts/Domo2/ResumenSumatoriaDomo2'
import TablaQuimicosDomo2 from '../../components/Charts/Domo2/TablaQuimicosDomo2'

import './Domo2.css'

const Domo2 = () => {

    const [state, setstate] = useState(null)
    const [stateModal, setstateModal] = useState(false)
    const arrayData = new Array(9)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { fInit() }, [])

    const fInit = () => {
        let auxArray = []
        for (let index = 0; index < Math.round(arrayData.length / 2); index++) {
            if (index + 1 !== Math.round(arrayData.length / 2)) auxArray.push(fArrayNode(-1, index, 'na' + index.toString()), fArrayNode(1, index, 'nb' + index.toString()))
            else {
                if (arrayData.length % 2 === 0) auxArray.push(fArrayNode(-1, index, 'na' + index.toString()), fArrayNode(1, index, 'nb' + index.toString()))
                else auxArray.push(fArrayNode(-1, index, 'na' + index.toString()))
            }
            if (index === Math.round(arrayData.length / 2) - 1) setstate(auxArray)
        }
    }

    const fArrayNode = (sumaResta, index, name) => {
        return {
            group: 'nodes',
            data: { id: name, label: index, style: { 'color': 'yellow' } },
            selected: true,
            position: { x: (index + 1) * 12 * sumaResta, y: 50 + index * 4 },
            locked: true,
            style: {
                'width': '25px', 'height': '25px', 'margin': '5px',
                'background-image': 'url(../../../../assets/IconEthernet/cono1.2.png)', "background-fit": "cover cover", 'background-opacity': '0'
            }
        }
    }

    return (
        <div className='minTopPage'>
            <Modal className="popup-theme-wrap" size="large" open={stateModal} scrolling={true} style={{ height: '480px' }}>
                <Modal.Content>
                    <ResumenSumatoriaDomo2 />
                </Modal.Content>
                <Modal.Footer style={{ marginTop: '0px' }}>
                    <Button type="secondary" content="Secondary" size="small" onClick={() => setstateModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
            <Grid className='mx-0 mb-0 px-0'>
                <Grid.Row className='titleResponsive'>
                    <TitlePage title='Modelo Domoaaaaaaaaaaaaaaaaaaaaaaaaaaaasdaweqeqwe' />
                </Grid.Row>
                <Grid.Row className='m-0 p-0'>
                    <Grid.Column width={12} sWidth={12} xsWidth={12} className='m-0 ps-2-pe-2-pb-1-pt-0'>
                        <Card style={{ minHeight: '270px', height: '400px' }} className='m-0 p-0'>
                            <Card.Header title="PILA EN RECLAMACIÓN">
                                {/*fButttonModal("PILA EN RECLAMACIÓN")*/}
                            </Card.Header>
                            <Card.Content>
                                <hr style={{ marginTop: '0px', marginBottom: '15px' }} />
                                <>
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            {
                                                state &&
                                                <PilaDomo2 />
                                            }
                                        </Grid.Column>
                                    </Grid.Row>
                                </>
                            </Card.Content>
                        </Card>
                    </Grid.Column>
{/* 

                    <Grid.Column width={6} sWidth={6} xsWidth={12} className='m-0 ps-0-pe-2-pb-1-pt-0' style={{display:'none'}}>
                        <Card style={{ minHeight: '270px' }}>
                            <Card.Header title="% MINERALÓGICO" style={{ marginBottom: '6px' }}>
                                <Icon name='increasing' root="common" />
                            </Card.Header>
                            <Card.Content>
                                <hr style={{ marginTop: '0px', marginBottom: '26px' }} />
                                <>
                                    <Grid.Row>
                                        <Grid.Column width={12}>
                                            <BarraDomo2
                                                body={{}}
                                                height={240}
                                                showInLegend={false}
                                                detail1='General'
                                                detail2='Reclamacion'
                                                name='% Pila en Formación'
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </>
                            </Card.Content>
                        </Card>
                    </Grid.Column>


*/}

                </Grid.Row>

                <Grid.Row>
                    <Grid.Column width={12}>
                        <Tab defaultActiveIndex={0}  > 
                            <Tab.Pane title="Mineralogía">
                                <TablaGeneralDomo body={{opcion: 4}} />
                            </Tab.Pane>
                            <Tab.Pane title="Granulometría">
                                <TablaGeneralDomo body={{opcion: 6}} />
                            </Tab.Pane>
                            <Tab.Pane title="Análisis Químico">
                                <TablaGeneralDomo body={{opcion: 5}}/>
                            </Tab.Pane>
                        </Tab>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    {/* <Grid width={12}>
                        <h6 className='letterDomo2'>Químicos</h6>
                    </Grid> */}
                    <Grid.Column width={12} sWidth={12} xsWidth={12} className='m-0 ps-2-pe-2-pb-1-pt-3'>
                        <Card  className='m-0 p-0'>
                            <Card.Header title="QUÍMICOS ALIMENTACIÓN AL TOSTADOR">
                                <Icon name='increasing' root="common" />
                            </Card.Header>
                            <Card.Content>
                                <TablaQuimicosDomo2 />
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                </Grid.Row>

            </Grid>
        </div >
    )
}

export default Domo2